import Icon, { icons } from '../../generic/Icon';
import type { TooltipPlacement } from '../../generic';
import Tooltip from '../../generic/Tooltip';
import type { Project } from '../../../types';

type Props = {
  project: Project;
  className?: string;
  placement?: TooltipPlacement;
};

/**
 * Returns either the Provided/upload icon, SBOM import icon or container icon.
 *
 * @param {Project} project - A given project.
 * @param {string} [className] - Optional classname to wrap the icon.
 * @param {TooltipPlacement} [placement] - Optional placement of the tooltip.
 */
const ProjectTypeIcon = ({
  project,
  className = 'project-table__row__icon',
  placement = 'top',
}: Props) => {
  const { require_mediated_dependencies, type } = project;
  if (type === 'container') {
    return (
      <Tooltip tooltip="Container" placement={placement}>
        <span className={className}>
          <Icon icon={icons.cube} />
        </span>
      </Tooltip>
    );
  }
  if (type === 'cyclonedx') {
    return (
      <Tooltip tooltip="SBOM Import" placement={placement}>
        <span className={className}>
          <Icon icon={icons.receipt} />
        </span>
      </Tooltip>
    );
  }
  if (require_mediated_dependencies) {
    return (
      <Tooltip tooltip="Provided" placement={placement}>
        <span className={className}>
          <Icon icon={icons.upload} />
        </span>
      </Tooltip>
    );
  }
  return null;
};

export default ProjectTypeIcon;
